export const LEAVE_TYPE = {
  leave: 'Cuti',
  sickLeave: 'Izin Sakit',
  suddenLeave: 'Izin Pulang Cepat',
  outsideAssignment: 'Tugas Luar',
};

export const ASSIGNMENT_TYPES = {
  31: 'Full',
  32: 'Pagi',
  33: 'Sore',
};

export const TYPES = [
  {
    label: 'Semua',
    id: '',
  },
  {
    label: 'Cuti',
    id: 'leave',
  },
  {
    label: 'Cuti Melahirkan',
    id: 'maternityLeave',
  },
  {
    label: 'Izin',
    id: 'permit',
  },
  {
    label: 'Izin Sakit',
    id: 'sickLeave',
  },
  {
    label: 'Pulang Cepat',
    id: 'suddenLeave',
  },
  {
    label: 'Tugas Luar',
    id: 'outsideAssignment',
  },
];

export const STATUSES = [
  {
    label: 'Semua',
    id: '',
  },
  {
    label: 'Menunggu Approval',
    id: 'pending',
  },
  {
    label: 'Diterima',
    id: 'approved',
  },
  {
    label: 'Ditolak',
    id: 'rejected',
  },
  {
    label: 'Dibatalkan',
    id: 'canceled',
  },
  {
    label: 'Diubah',
    id: 'edited',
  },
];

export const TRANSPORTATION_TYPES = {
  0: 'Mobil',
  1: 'Kereta',
  2: 'Pesawat',
  3: 'Kapal Laut',
  4: 'Motor',
};

export const ACCOMODATION_TYPES = {
  0: 'Hotel',
  1: 'Mess',
  2: 'Lainnya',
};
